import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '.';

/**
 * Fetches body areas from Firebase collection
 * @returns {Promise<Array>} Promise with array of ParentArea objects
 */
export async function fetchBodyAreas() {
  try {
    const FIREBASE_COLLECTION = process.env.REACT_APP_BODY_AREAS_COLLECTION;
    const collectionRef = collection(db, FIREBASE_COLLECTION);
    const q = query(collectionRef, orderBy('index'));
    const snapshot = await getDocs(q);

    const fetchedData = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Sort areas within each parent area
    fetchedData.forEach((doc) => {
      doc.areas.sort((a, b) => a.name.localeCompare(b.name));
    });
    fetchedData.forEach((doc) => {
      doc.areas.sort((a, b) => a.index - b.index);
    });

    return fetchedData;
  } catch (error) {
    console.error('Error fetching body areas:', error);
    throw error;
  }
}
